import React from 'react';
import styled from 'styled-components';
import { Text } from './ui';
import type { LinkProps } from 'next/link';
import Link from 'next/link';
import { useRouter } from 'next/router';

const NavLinkBg = styled.span<{ isActive: boolean }>`
  box-sizing: border-box;
  padding-top: 6px;
  border-width: 0;
  border-bottom-width: 6px;
  border-style: solid;
  border-bottom-color: ${(props) =>
    props.isActive ? '#ffe552' : 'transparent'};
  cursor: pointer;
  display: inline-block;
`;

const NavLinkText = styled(Text)`
  color: #fff;
  display: flex;
  height: 36px;
  padding-right: 15px;
  padding-left: 15px;
  align-items: center;
  font-size: 0.875rem;
  font-weight: bold;
  text-decoration: none;
  user-select: none;
`;

NavLinkText.displayName = 'NavText';

export const NavLink = ({
  children,
  label,
  ...props
}: LinkProps & { children: React.ReactNode; label: string }) => {
  const { asPath } = useRouter();

  const linkPathname = new URL(
    props.as?.toString() || props.href.toString(),
    location.href,
  ).pathname;

  // Using URL().pathname to get rid of query and hash
  const activePathname = new URL(asPath, location.href).pathname;

  const isActive = linkPathname === activePathname;

  return (
    <Link {...props}>
      <NavLinkBg isActive={isActive} aria-label={label}>
        <NavLinkText>{children}</NavLinkText>
      </NavLinkBg>
    </Link>
  );
};

NavLink.displayName = 'NavLink';

export default NavLink;
